<div class="datacardCharts mt-1">
  <app-bar-chart class="p-3" [chatResp]="interactionsVsTime"></app-bar-chart>
</div>
